export default "__VITE_ASSET__19daa262__"